import React from 'react';
import { translate } from 'game/translate';

interface DesignButtonProps {
  type: 'main' | 'secondary';
  onClick: () => void;
  isSelected?: boolean;
}

export const DesignButton: React.FC<DesignButtonProps> = ({ onClick, type, isSelected }) => {
  return (
    <div id="closing-ignore-el" style={isSelected ? { background: 'rgba(31, 31, 31, 0.40)' } : {}} className={`mission-button design-button--${type} w-100 d-flex justify-content-center ${type === 'secondary' ? 'side-bar-button--secondary-wrapper' : 'side-bar-button--wrapper'}`}>
      <button 
        id="designButton" 
        onClick={onClick}
        className={`${type === 'secondary' ? 'side-bar-button side-bar-button--secondary' : 'side-bar-button'} position-relative d-flex align-items-center justify-content-center w-100`}
      >
        <picture>
          <source srcSet={`/assets/menu/icon_design.webp`} type="image/webp" />
          <img style={{ height: '50px' }} src={`/assets/menu/icon_design.png`} alt="Design" />
        </picture>

        <span>
          {translate('menu_design')}
        </span>
      </button>
    </div>
  );
};


